/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Table, Switch, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getJackpots,
  updateJackpotStatus,
  deleteJackpot,
  refreshJackpot,
} from "../../features/jackpot/jackpotSlice";
import { Link } from "react-router-dom";
import { Input } from "antd";
import { Select } from "antd";
import { IoSearchOutline } from "react-icons/io5";
import { Modal } from "antd";
import { message as msg } from "antd";

const formatDate = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const Jackpot = () => {
  const [messageApi, contextHolder] = msg.useMessage();

  const [searchQuery, setSearchQuery] = useState("");
  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
    setPagination({
      ...pagination,
      current: 1,
      key: event.target.value,
    });
  };

  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    key: "",
    status: "",
    type: "hole-in-one"
  });

  useEffect(() => {
    loadJackpots();
  }, [pagination]);

  async function loadJackpots() {
    dispatch(getJackpots(pagination));
  }

  const { isLoading, jackpots, total } = useSelector((state) => state.jackpot);

  const handleTableChange = (pagination) => {
    dispatch(getJackpots(pagination));
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      total: total,
    }));
  }, [total]);

  const handleStatusChange = async (checked, record) => {
    const newStatus = checked ? 1 : 0;
    const { payload } = await dispatch(
      updateJackpotStatus({ id: record.id, data: { status: newStatus } })
    );
    if (payload && payload.response && payload.response.status !== 200) {
      messageApi.open({
        type: "error",
        content: payload.response.data.message,
      });
    }
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this jackpot?",
      content: "This action cannot be undone.",
      onOk: () => {
        // Dispatch the delete action if confirmed
        dispatch(deleteJackpot({ id: id }));
      },
      onCancel() {
        // Optional: handle cancellation
      },
    });
  };

  const handleRefresh = (id) => {
    Modal.confirm({
      title: "Are you sure you want to refresh this jackpot?",
      content: "This action cannot be undone.",
      onOk: () => {
        // Dispatch the delete action if confirmed
        dispatch(refreshJackpot({ id: id }));
      },
      onCancel() {
        // Optional: handle cancellation
      },
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Winning Prize",
      dataIndex: "winning_prize",
      key: "winning_prize",
      render: (winning_price, record) => <span>{record.prize_type === 'cash' ? record.currency + record.winning_price : record.winning_item}</span>,
    },
    {
      title: "Accumulated Price",
      dataIndex: "accumulated_entry_price",
      key: "accumulated_entry_price",
    },
    {
      title: "Points",
      dataIndex: "points",
      key: "points",
    },
    {
      title: "Entry Price",
      dataIndex: "entry_price",
      key: "entry_price",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => <span>{formatDate(createdAt)}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <span>
          <Switch
            checked={status === 1}
            onChange={(checked) => handleStatusChange(checked, record)}
          />
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (status, record) => (
        <span>
          <Link to={`/admin/hole-in-one-prize/${record.id}`}>Edit</Link>
          <span style={{ margin: "0 10px" }}>|</span>
          <a
            onClick={() => handleDelete(record.id)}
            style={{ color: "red", cursor: "pointer" }}
          >
            Delete
          </a>
          <span style={{ margin: "0 10px" }}>|</span>
          <a
            onClick={() => handleRefresh(record.id)}
            style={{ color: "red", cursor: "pointer" }}
          >
            Refresh
          </a>
        </span>
      ),
    },
  ];

  // Handle key down events on search
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setPagination({
        ...pagination,
        current: 1,
        key: searchQuery,
      });
    }
  };

  /** Handle dorp down for status is changed call search */
  const handleChange = (value) => {
    setPagination({
      ...pagination,
      current: 1,
      status: value,
    });
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Challenges</h3>
      <div className="row-space-between">
        <Link to="/admin/hole-in-one-prize/create">
          <Button type="primary" htmlType="submit">
            Add New
          </Button>
        </Link>
        <div className="my-row">
          <div className="mr-5">
            <Input
              placeholder="Search Challenge"
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              prefix={<IoSearchOutline className="fs-4" />}
            />
          </div>

          <div>
            <Select
              defaultValue="All"
              style={{ width: 120 }}
              onChange={handleChange}
              options={[
                { value: "", label: "All" },
                { value: "1", label: "Active" },
                { value: "0", label: "Inactive" },
              ]}
            />
          </div>
        </div>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={jackpots}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default Jackpot;
